export interface IIoCContainer {
    lateBindIoC(): void;
}
